import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import SingleAttachment from '../../shared/singleAttachment.component';
import { attachmentPropType } from './propTypes';

class AttachmentsTab extends PureComponent {
  static propTypes = {
    attachments: PropTypes.arrayOf(attachmentPropType).isRequired,
  };

  render() {
    const attachmentsToDisplay = this.props.attachments.map(attachment => ({
      id: attachment.ATTACHMENT_ID,
      fileName: attachment.FILE_NAME,
      fileType: attachment.FILE_TYPE,
      fileImage: attachment.FILE_IMAGE,
    }));

    return (
      <div className="attachments-tab">
        {attachmentsToDisplay.map(attachment => (
          <SingleAttachment
            file={attachment}
            key={attachment.fileName}
          />
        ))}
      </div>
    );
  }
}

export default AttachmentsTab;
